// TODO: Client Msg로 바꿔야 함
export const EXCEL_UPLOAD_ERROR_CODE = {
  EXCELUPLOAD_001: 'EXCELUPLOAD001',
  EXCELUPLOAD_002: 'EXCELUPLOAD002',
  EXCELUPLOAD_003: 'EXCELUPLOAD003',
  EXCELUPLOAD_004: 'EXCELUPLOAD004',
  EXCELUPLOAD_005: 'EXCELUPLOAD005',
  EXCELUPLOAD_006: 'EXCELUPLOAD006',
  EXCELUPLOAD_007: 'EXCELUPLOAD007',
};

const EXCEL_UPLOAD_ERROR_MESSAGE = {
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_001]: '엑셀 시트 행의 길이는 1 이상입니다.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_002]: '유효하지 않은 파일입니다. 파일을 확인해주세요.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_003]: '파일이 첨부 되지 않았습니다.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_004]: '유효하지 않은 파일입니다.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_005]: '파일 용량은 최대 20MB 까지만 업로드 가능 합니다.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_006]: '확장자가 xlsx 문서만 업로드 가능합니다.',
  [EXCEL_UPLOAD_ERROR_CODE.EXCELUPLOAD_007]: '엑셀 파일의 행은 최대 1,000개 까지만 업로드 가능 합니다.',
};

export default EXCEL_UPLOAD_ERROR_MESSAGE;
